<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-item
            :key="item.text"
            link
            :to="item.link"
            replace
            v-if="
              !(user.data.color === 'text' && user.data.email === 't.schnetz')
            "
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item
          link
          to="textgen"
          replace
          v-if="user.data.color === 'text'"
        >
          <v-list-item-action>
            <v-icon>mdi-text</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Text Generator </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="green darken-1"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Hunter</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon large v-on="on" v-bind="attrs">
            <v-avatar size="32px" item color="red">
              <Avatar
                v-if="user.data"
                :username="user.data.email.replace('.', ' ')"
              ></Avatar>
              <v-icon dark v-else>mdi-account-circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <router-view />
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import Avatar from 'vue-avatar';

export default {
  props: {
    source: String,
  },
  components: {
    Avatar,
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  methods: {
    logout() {
      this.$store.commit('SET_LOGOUT');
      this.$router.push({ path: 'login' });
    },
  },
  data: () => ({
    dialog: false,
    drawer: null,
    items: [
      { icon: 'mdi-chart-bar', text: 'Stats', link: '/', show: true },
      { icon: 'mdi-account-group', text: 'Leads', link: 'leads', show: true },
      {
        icon: 'mdi-view-dashboard',
        text: 'Backend',
        link: 'admin',
        show: true,
      },
      // {
      //   icon: 'mdi-alarm-check',
      //   text: 'Alte Leads',
      //   link: 'old_leads',
      //   show: true,
      // },
    ],
  }),
};
</script>
